// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__zJiLW","default":"Checkbox_default___w6LY","disabled":"Checkbox_disabled__HfSYg","checked":"Checkbox_checked__kIeVC"};